var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.viewerContext.institutionType ===
					'BOOKSTORE')?_c('BSSuggestionsListViewer',{attrs:{"suggestionsListId":this.$route.params.suggestionsListId}}):_c('LSuggestionsListViewer',{attrs:{"suggestionsListId":this.$route.params.suggestionsListId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }